(function () {
    'use strict';

    angular.module('app.location', ['ngCookies']);
})();